import { ApiOutlined } from '@ant-design/icons'
import { Input, Switch } from 'antd'
import { bool, func, object } from 'prop-types'
import React, { useCallback } from 'react'

import { FormItem, styleIconValidation } from './base/styles'
import { Widget, useUpdate, useValidation } from './base/widget'
import { CommonFields } from './base/widgetCommonFields'

export const DatabaseWidget = React.memo((props) => {
	const { data } = props

	const update = useUpdate(props)
	const [valid, setValid] = useValidation(props)

	const updateVariable = useCallback(
		(key, value) => {
			update({ variable: { ...data.variable, [key]: value } })
		},
		[data, update]
	)

	return (
		<Widget
			{...props}
			type={'API'}
			icon={<Icon $error={!valid} />}
			onValidate={setValid}
			formItems={
				<div>
					<CommonFields
						data={data}
						update={update}
						extraFields={
							<ExtraField option={data.remove_autocomplete} update={update} />
						}
					/>

					<FormItem label="Endpoint">
						<Input
							onBlur={(e) =>
								updateVariable('database_endpoint', e.target.value)
							}
							defaultValue={data?.variable?.database_endpoint}
							autoComplete="off"
						/>
					</FormItem>

					<FormItem label="Atributos">
						<Input.Group compact>
							<Input
								placeholder="Índice"
								onBlur={(e) => updateVariable('search_key', e.target.value)}
								defaultValue={data?.variable?.search_key}
								autoComplete="off"
								style={{
									width: '50%',
									textAlignLast: 'center',
								}}
							/>

							<Input
								placeholder="Exibição"
								onBlur={(e) => updateVariable('display_key', e.target.value)}
								defaultValue={data?.variable?.display_key}
								autoComplete="off"
								style={{
									width: '50%',
									textAlignLast: 'center',
								}}
							/>
						</Input.Group>
					</FormItem>
				</div>
			}
		/>
	)
})

const Icon = styleIconValidation(ApiOutlined)

DatabaseWidget.propTypes = {
	data: object,
}

function ExtraField({ option, update }) {
	return (
		<FormItem
			style={{ alignSelf: 'flex-end', marginRight: 48 }}
			label="Sem autocomplete"
			$width={'fit-content'}
			$labelWidth={'fit-content'}
			$labelTop={'1px'}>
			<Switch
				defaultChecked={option}
				onChange={(e) =>
					update({
						remove_autocomplete: e,
					})
				}
			/>
		</FormItem>
	)
}

ExtraField.propTypes = {
	option: bool,
	update: func,
}
